import useNotifications from './hooks/useNotifications';
import Logo from '../../../../assets/images/logo.svg';
import {PageTitle} from '../../../common/providers/PageDataProvider';
import {useI18n} from '../../../common/providers/I18nProvider';
import PathComponent from '../../../common/components/path/PathComponent';

const Notifications = () => {
	const {data, error} = useNotifications();
	const {i18n} = useI18n();

	if (error) {
		return <h3 className='text-lg'> {i18n('ERROR.MODAL.TITLE')} </h3>;
	}

	return (
		<>
			<PageTitle>{i18n('LAYOUT.SIDEBAR.MENU.DASHBOARD')}</PageTitle>
			<PathComponent
				parents={[{label: i18n('LAYOUT.SIDEBAR.MENU.DASHBOARD'), link: 'dashboard'}]}
				child={i18n('DASHBOARD.NOTIFICATIONS')}
			/>
			<div className='bg-white p-2 md:p-10'>
				{data?.data && data.data.length !== 0 ? (
					data.data.map((nd) => (
						<div className='flex gap-4 mb-6' key={nd.id}>
							{nd.img_url ? <img src={nd.img_url} alt='icon' /> : <img src={Logo} alt='icon' />}
							<div>
								{nd.title ? (
									<h3 className='text-sm md:text-lg font-semibold'>{nd.title}</h3>
								) : (
									<h3 className='text-sm md:text-lg font-semibold'> </h3>
								)}
								{nd.description ? (
									<p className='text-xs md:text-lg break-all sm:break-all'>{nd.description}</p>
								) : (
									<p className='text-xs md:text-lg'> </p>
								)}
								<p className='text-sm md:text-md text-gray-400'>{nd.created_at}</p>
							</div>
						</div>
					))
				) : (
					<p className='text-lg text-gray-300'> {i18n('LAYOUT.HEADER.NOTIFICATION.EMPTY')} </p>
				)}
			</div>
		</>
	);
};

export default Notifications;
